// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3Uocv","text":"SelectPayment_text__3DPfv","title":"SelectPayment_title__1jN4Q","btn":"SelectPayment_btn__euJ4R"};